import React, { useEffect, useState } from "react";

const UserList = () => {
  // State variables
  const [users, setUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  // Fetch data on mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch("https://jsonplaceholder.typicode.com/users");
        if (!res.ok) throw new Error("Failed to fetch users");
        const data = await res.json();
        setUsers(data);
        setFiltered(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  // Handle search filter
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filteredUsers = users.filter((u) =>
      u.name.toLowerCase().includes(value)
    );
    setFiltered(filteredUsers);
  };

  // Conditional rendering
  if (loading) return <p style={styles.loading}>Loading users...</p>;
  if (error) return <p style={styles.error}>Error: {error}</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>👥 User Directory</h2>

      {/* Controlled Input */}
      <input
        type="text"
        placeholder="Search by name..."
        value={search}
        onChange={handleSearch}
        style={styles.input}
      />

      {/* Rendering list */}
      <ul style={styles.list}>
        {filtered.length > 0 ? (
          filtered.map((user) => (
            <li key={user.id} style={styles.card}>
              <h3>{user.name}</h3>
              <p>{user.email}</p>
              <p>{user.company.name}</p>
              <button
                style={styles.button}
                onClick={() => alert(`Hello, ${user.name}!`)}
              >
                Say Hi 👋
              </button>
            </li>
          ))
        ) : (
          <p>No users found.</p>
        )}
      </ul>
    </div>
  );
};

// Simple inline CSS
const styles = {
  container: {
    maxWidth: "600px",
    margin: "40px auto",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    fontFamily: "sans-serif",
  },
  title: { textAlign: "center", marginBottom: "10px" },
  input: {
    width: "100%",
    padding: "8px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  list: { listStyle: "none", padding: 0 },
  card: {
    padding: "10px",
    border: "1px solid #eee",
    borderRadius: "8px",
    marginBottom: "10px",
  },
  button: {
    marginTop: "8px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  loading: { textAlign: "center" },
  error: { color: "red", textAlign: "center" },
};

export default UserList;
